import { BrowserRouter } from 'react-router-dom';

import { MotionConfig } from 'framer-motion';
import { Toaster } from 'sonner';

import {
  ScrollContainerProvider,
  useDeepLink,
  useForegroundPushToast,
  useNativeSync,
  usePushSetup,
  usePushTap,
  useScrollContainerRef,
  useScrollRestoration,
} from '../hooks';
import { OfflineBar } from './components/OfflineBar';
import { QueryProvider } from './providers';
import { AppRoutes } from './routes';

const AppBody = () => {
  const scrollRef = useScrollContainerRef();

  // Native-shell integrations (no-ops in a plain browser). Must run
  // inside <BrowserRouter> so they can call useNavigate.
  useDeepLink();
  useNativeSync();
  // Push: register the device token, navigate on notification tap, and
  // toast foreground pushes.
  usePushSetup();
  usePushTap();
  useForegroundPushToast();
  // Restore scroll on back/forward. Targets the `.app-scroll` container
  // below — the document itself never scrolls.
  useScrollRestoration();

  return (
    <>
      <OfflineBar />
      <div ref={scrollRef} className="app-scroll">
        <AppRoutes />
      </div>
      <Toaster
        position="top-center"
        richColors
        offset="calc(var(--safe-area-top, env(safe-area-inset-top, 0px)) + 1rem)"
        // Mobile shows a fixed h-12 (3rem) header below the safe area, so
        // clear it (+3.5rem) or toasts render behind the header.
        mobileOffset="calc(var(--safe-area-top, env(safe-area-inset-top, 0px)) + 3.5rem)"
      />
    </>
  );
};

const AppInner = () => (
  <ScrollContainerProvider>
    <AppBody />
  </ScrollContainerProvider>
);

export const App = () => {
  return (
    <QueryProvider>
      <BrowserRouter>
        <MotionConfig reducedMotion="user">
          <AppInner />
        </MotionConfig>
      </BrowserRouter>
    </QueryProvider>
  );
};
